// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_shell__YfA0h {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  min-height: 100vh;
}

.Layout_main__OG2sf {
  min-width: 0;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Layout_topbar__UID57 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  overflow-wrap: anywhere;
}

.Layout_card__c1LRI {
  background: var(--card);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(13, 38, 63, 0.06);
  padding: 16px;
}

@media (max-width: 800px) {
  .Layout_shell__YfA0h {
    grid-template-columns: minmax(0, 1fr);
  }
  .Layout_main__OG2sf {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/layout/Layout.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2CAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;AACF;;AAEA;EACE;IAAS,qCAAA;EAET;EADA;IAAQ,aAAA;EAIR;AACF","sourcesContent":[".shell {\n  display: grid;\n  grid-template-columns: 260px minmax(0, 1fr);\n  min-height: 100vh;\n}\n\n.main {\n  min-width: 0;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  overflow-wrap: anywhere;\n}\n\n.card {\n  background: var(--card);\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(13, 38, 63, .06);\n  padding: 16px;\n}\n\n@media (max-width: 800px) {\n  .shell { grid-template-columns: minmax(0, 1fr); }\n  .main { padding: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `Layout_shell__YfA0h`,
	"main": `Layout_main__OG2sf`,
	"topbar": `Layout_topbar__UID57`,
	"card": `Layout_card__c1LRI`
};
export default ___CSS_LOADER_EXPORT___;
